import React, { useContext, useState } from "react";
import { SettingsContext } from "../providers/SettingsProvider";
import Footer from "./Footer";
import IdentifierBar from "./IdentifierBar";
import { v4 as uuidv4 } from "uuid";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import InfoIcon from "@mui/icons-material/Info";
import { processReminder } from "../helperFunctions/dateFormatters";
import "../css/businessInfoPage.scss";

export const BusinessInfoCard = (props) => {
  const [descVisible, setDescVisible] = useState(false);
  let { bInfo, handleAlteration, removeInfo } = props;

  let reminder = processReminder(bInfo);
  let isActiveNote = reminder.expired || reminder.warning;
  let colorStatus = isActiveNote ? "red" : "inherit";

  return (
    <div className="reminder-container">
      <div className={bInfo.category}>
        <input
          data-infoid={bInfo.uid}
          type="text"
          className="infoTitle"
          style={{ borderColor: colorStatus }}
          name="title"
          defaultValue={bInfo?.title}
          onBlur={handleAlteration}
        />
        <input
          type="date"
          name="value"
          className="infoValue"
          style={{ borderColor: colorStatus }}
          data-infoid={bInfo.uid}
          value={bInfo?.value}
          onChange={handleAlteration}
        />
        <button
          className="toggleDesc"
          data-infoid={bInfo.uid}
          onClick={() => {
            setDescVisible((prevState) => !prevState);
          }}
        >
          {bInfo.show ? <InfoIcon /> : <InfoIcon />}
        </button>

        <button
          className="toggleInfo"
          data-infoid={bInfo.uid}
          onClick={() =>
            handleAlteration({
              target: {
                name: "show",
                value: !bInfo.show,
                dataset: {
                  infoid: bInfo.uid,
                },
              },
            })
          }
        >
          {bInfo.show ? <VisibilityIcon /> : <VisibilityOffIcon />}
        </button>

        <button
          className="removeInfo"
          data-infoid={bInfo.uid}
          onClick={removeInfo}
        >
          X
        </button>

        <br />
      </div>
      {descVisible && (
        <div className="infoDescription">
          <textarea
            rows={2}
            type="text"
            name="desc"
            className="infoDesc"
            style={{ borderColor: colorStatus }}
            data-infoid={bInfo.uid}
            value={bInfo?.desc}
            onChange={handleAlteration}
          />
        </div>
      )}
    </div>
  );
};

const BusinessInfo = () => {
  const {
    addBusinessInfo,
    removeBusinessInfo,
    alterBusinessInfo,
    businessInfo,
  } = useContext(SettingsContext);

  const [info, setInfo] = useState({
    title: "",
    value: "",
    uid: "",
    desc: "",
    show: true,
    category: "reminder",
  });

  function handleInput(e) {
    let value = e.target.value;
    let name = e.target.name;
    setInfo({ ...info, [name]: value });
  }

  function handleAlteration(e) {
    // Handles alteration to established dates.
    let infoUid = e.target.dataset.infoid;

    let value = e.target.value;
    let name = e.target.name;

    alterBusinessInfo(infoUid, name, value);
  }

  async function addInfo() {
    let uid = uuidv4();
    addBusinessInfo({ ...info, uid: uid }).then((v) => {
      setInfo({ ...info, title: "", value: "", uid: "", desc: "" });
    });
  }

  function removeInfo(e) {
    let infoUid = e.target.dataset.infoid;

    removeBusinessInfo(infoUid);
  }

  return (
    <div className="businessInfoPage">
      <Footer title="Business Information" back={true}></Footer>

      <IdentifierBar title="Business Information" back={true} />

      <div className="reminders">
        <h3>Reminders</h3>

        <div className="addInfo">
          <div className="addLine1">
            <div className="addTitle">
              <label htmlFor="title">Title</label>
              <input
                name="title"
                id="title"
                value={info.title ?? ""}
                onChange={handleInput}
                type="text"
              />
            </div>
            <div className="addValue">
              <label htmlFor="value">Date</label>
              <input
                name="value"
                id="value"
                type="date"
                value={info?.value}
                onChange={handleInput}
              />
            </div>
            <button onClick={addInfo}>Add</button>
          </div>
          <div className="addLine2">
            <textarea
              className="extra-info"
              placeholder="extra information"
              name="desc"
              value={info.desc ?? ""}
              onChange={handleInput}
              rows={2}
            />
          </div>
        </div>

        <hr />
        <br />
        <br />
        <div className="infoList">
          {businessInfo.map((bInfo) => {
            return (
              <BusinessInfoCard
                key={bInfo.uid}
                bInfo={bInfo}
                handleAlteration={handleAlteration}
                removeInfo={removeInfo}
              />
            );
          })}
        </div>
      </div>

      <br />
      <br />
    </div>
  );
};

export default BusinessInfo;
